import React from "react";
import "./analytics.css";
import Chart from "../../components/chart/Chart";
import { salesdata } from "../../components/incomingdata/dummydata";

export default function Analytics() {
  return (
    <div className="analytics">
      <Chart
        data={salesdata}
        title="Real Time Monthly Fuel Usage"
        grid
        dataKey="fuel"
      />
    </div>
  );
}
